import React, { Component } from 'react';
import Tenants from './Tenants';
import AIUsers from './AIUsers';
import Groups from './Groups';
import AICompanies from './AICompanies';
import './IamDetailsCard.css';
import { Link } from 'react-router-dom';
import { getLink } from '../search/CustomerCard';

class IamDetails extends Component {
  render() {
    const { iamDetails } = this.props;
    const customerCardLink = getLink({
      id: iamDetails.customerAccountId
        ? iamDetails.customerAccountId
        : iamDetails.id
    });

    return (
      <table>
        <tbody className="iam_details_card_tbody">
          <tr>
            <td>Customer Account Id</td>
            <td>
              <Link className="Link" to={customerCardLink}>
                {iamDetails.customerAccountId
                  ? iamDetails.customerAccountId
                  : 'No customer found'}
              </Link>
            </td>
          </tr>
          <tr>
            <td>{`${
              iamDetails.env === 'organization'
                ? 'Organization'
                : 'Organization Sandbox'
            } Id`}</td>
            <td>{iamDetails.organization.id}</td>
          </tr>
          <tr>
            <td>Created Date</td>
            <td>
              {new Date(
                iamDetails.organization.meta.created
                  ? iamDetails.organization.meta.created
                  : 'N/A'
              ).toLocaleDateString()}
            </td>
          </tr>
          <tr>
            <td>createdBy</td>
            <td>
              {iamDetails.organization.meta.createdBy
                ? iamDetails.organization.meta.createdBy
                : 'N/A'}
            </td>
          </tr>
          <tr>
            <td>Modified Date</td>
            <td>
              {new Date(
                iamDetails.organization.meta.lastModified
                  ? iamDetails.organization.meta.lastModified
                  : 'N/A'
              ).toLocaleDateString()}
            </td>
          </tr>
          <tr>
            <td>ModifiedBy</td>
            <td>
              {iamDetails.organization.meta.modifiedBy
                ? iamDetails.organization.meta.modifiedBy
                : 'N/A'}
            </td>
          </tr>
          <tr>
            <td>Tenants</td>
            <Tenants
              name="Tenants"
              data={iamDetails.tenants ? iamDetails.tenants : []}
            />
          </tr>
          <tr>
            <td>Groups</td>
            <Groups
              name="Groups"
              data={iamDetails.groups ? iamDetails.groups : []}
            />
          </tr>
          <tr>
            <td>Companies</td>
            <AICompanies
              name="AICompanies"
              data={iamDetails.companies ? iamDetails.companies : []}
            />
          </tr>
          <tr>
            <td>Users</td>
            <AIUsers
              name="AIUsers"
              data={iamDetails.users ? iamDetails.users : []}
            />
          </tr>
        </tbody>
      </table>
    );
  }
}

export default IamDetails;
